import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 15"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M8 8.684a4.312 4.312 0 1 1 4.313-4.313A4.32 4.32 0 0 1 8 8.684Zm0-7.5a3.187 3.187 0 1 0 3.188 3.187A3.195 3.195 0 0 0 8 1.184Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M14.75 14.684a.57.57 0 0 1-.563-.563A5.445 5.445 0 0 0 8.75 8.684h-1.5a5.445 5.445 0 0 0-5.438 5.437.562.562 0 1 1-1.125 0A6.57 6.57 0 0 1 7.25 7.56h1.5a6.57 6.57 0 0 1 6.563 6.562.57.57 0 0 1-.563.563Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }